import { once } from './once';

export const getGlobalFeedbackElement = once(() => {
    const globalFeedbackElement = document.createElement(`p`);
    globalFeedbackElement.style.textAlign = `center`;
    globalFeedbackElement.style.background = `red`;
    globalFeedbackElement.style.fontSize = `0.75rem`;
    globalFeedbackElement.style.padding = `0.25rem`;
    document.body.prepend(globalFeedbackElement);
    return globalFeedbackElement;
});
